import styles from "./index.module.scss";
import WithModal, { CommonModalPropsI } from "@components/HOC/withModals";
import { MODALS_ENUM } from "@constants/Modals";
import Title from "@components/global/new/Title/Title";
import Button from "@components/global/new/Button/Button";
import { useEffect, useRef } from "react";
import { show } from "redux-modal";
import { Dispatch } from "redux";
import { IRackItem } from "@components/Pages/Locations/LocationRow/LocationMore/RackTable/Rack/RackItem/RackItem.props";
import { MinerControlAction } from "@services/minerContol";

export type ControlType = MinerControlAction;

interface ConfirmMinersOnOffPropsI {
  miners: IRackItem[];
  on: ControlType;

  title?: string;
  subtitle?: string;

  onConfirm(): void;
  onCancel?(): void;
}

function ConfirmMinersOnOff({
  title,

  handleClose,
  onCancel,
  onConfirm,
  formatMessage,
  ...props
}: ConfirmMinersOnOffPropsI & CommonModalPropsI) {

  const onConfirmHandler = () => {
    onConfirm();
    handleClose();
  };

  const onCancelHandler = () => {
    onCancel && onCancel();
    handleClose();
  };

  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (ref.current && ref.current.parentElement) {
      ref.current.parentElement.style.width = "500px";
    }
  }, [ref]);

  return (
    <div className={styles.wrapper} ref={ref}>
      <Title className={styles.title}>
        {title || formatMessage({ id: "modal.confirm.title" })}
      </Title>
      {props.subtitle && (
        <Title className={styles.subtitle}>{props.subtitle}</Title>
      )}

      <div className={styles.changesInfo}>
        <label>
          {
            (props.miners?.length ?? 0) === 1
            ? formatMessage({ id: 
              props.on === "start" 
                ? "locations.scheme.one_miner_start" 
                : props.on === "stop"
                ? "locations.scheme.one_miner_stop" 
                : "locations.scheme.one_miner_restart"
              }).replace(
                "#",
                props.miners[0].miner_name,
              )
            : formatMessage({ id: 
                props.on === "start" 
                  ? "locations.scheme.miners_start" 
                  : props.on === "stop"
                  ? "locations.scheme.miners_stop" 
                  : "locations.scheme.miners_restart"
              }).replace(
                "#",
                `${props.miners?.length || 0}`
              )
          }
        </label>
      </div>

      <div className={styles.btns}>
        <Button onClick={onConfirmHandler}>
          {formatMessage({ id: "modal.confirm.btn.yes" })}
        </Button>
        <Button onClick={onCancelHandler}>
          {formatMessage({ id: "modal.confirm.btn.no" })}
        </Button>
      </div>
    </div>
  );
}

export default WithModal(
  MODALS_ENUM.CONFIRM_MINERS_ONOFF_MODAL,
  ConfirmMinersOnOff,
  {
    style: {
      width: "500px",
    },
  }
);

export const confirmMinersOnOff = (
  dispatch: Dispatch,
  miners: IRackItem[],
  on: ControlType,
): Promise<boolean> => {
  return new Promise<boolean>((resolve) => {
    const props: ConfirmMinersOnOffPropsI & { onClosing: () => void } = {
      miners,
      on,
      onConfirm() {
        resolve(true);
      },
      onCancel() {
        resolve(false);
      },
      onClosing() {
        resolve(false);
      },
    };
    dispatch(show(MODALS_ENUM.CONFIRM_MINERS_ONOFF_MODAL, props));
  });
};
